import * as React from "react";

// Legal nav icon — ported from the V1 sidebar (SbLayoutComponent).
const LegalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.99 1.13039C15.97 0.720387 15.66 0.360387 15.21 0.260387C12.26 -0.359613 9.84 0.130387 8 1.70039C6.16 0.130387 3.74 -0.359613 0.78 0.260387C0.33 0.350387 0.03 0.720387 0.01 1.13039H0V13.1304C0 13.2104 0 13.3004 0.02 13.3904C0.14 13.9004 0.67 14.2104 1.21 14.1004C3.84 13.5504 5.8 14.0604 7.22 15.6704C7.24 15.7004 7.28 15.7104 7.3 15.7304C7.32 15.7504 7.33 15.7704 7.35 15.7904C7.39 15.8204 7.44 15.8304 7.48 15.8604C7.53 15.8904 7.57 15.9104 7.62 15.9304C7.73 15.9704 7.85 16.0004 7.97 16.0004C7.98 16.0004 7.98 16.0004 7.99 16.0004C8 16.0004 8 16.0004 8.01 16.0004C8.13 16.0004 8.25 15.9704 8.36 15.9304C8.41 15.9104 8.45 15.8804 8.5 15.8604C8.54 15.8404 8.59 15.8204 8.63 15.7904C8.65 15.7704 8.66 15.7504 8.68 15.7304C8.71 15.7104 8.74 15.7004 8.76 15.6704C10.18 14.0704 12.15 13.5504 14.77 14.1004C15.31 14.2104 15.84 13.8904 15.96 13.3904C16 13.3004 16 13.2104 16 13.1304L15.99 1.13039ZM7 12.9904C5.6 12.1604 3.93 11.8504 2 12.0604V1.96039C4.11 1.68039 5.75 2.16039 7 3.42039V12.9904ZM14 12.0704C12.07 11.8604 10.4 12.1704 9 13.0004V3.42039C10.25 2.16039 11.89 1.68039 14 1.96039V12.0704Z"
      fill="currentColor"
    />
  </svg>
);

export default LegalIcon;
